export const errMsg = (e, fallback = 'No se pudo completar') => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join('; ');
  return (typeof d === 'string' && d) || e?.message || fallback;
};
